import { useState, useEffect } from "react";
import api from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Badge } from "../components/ui/badge";

export default function AdminAuditPage() {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [actionFilter, setActionFilter] = useState("all");

  useEffect(() => { fetchLogs(); }, [actionFilter]);

  const fetchLogs = async () => {
    try {
      const params = { limit: 100 };
      if (actionFilter && actionFilter !== "all") params.action = actionFilter;
      const res = await api.get("/admin/audit-logs", { params });
      setLogs(res.data.items || []);
      setTotal(res.data.total || 0);
    } catch { setLogs([]); }
  };

  return (
    <div data-testid="admin-audit-page" className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight" style={{ fontFamily: "Chivo, sans-serif" }}>Audit Logs</h1>
          <p className="text-sm text-gray-500 mt-1">{total} events recorded</p>
        </div>
        <Select value={actionFilter} onValueChange={setActionFilter}>
          <SelectTrigger className="w-[200px] rounded-sm h-9"><SelectValue placeholder="All Actions" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Actions</SelectItem>
            <SelectItem value="login">Login</SelectItem>
            <SelectItem value="logout">Logout</SelectItem>
            <SelectItem value="quotation_created">Quotation Created</SelectItem>
            <SelectItem value="quotation_submitted">Quotation Submitted</SelectItem>
            <SelectItem value="order_created">Order Created</SelectItem>
            <SelectItem value="approval_approved">Approval Approved</SelectItem>
            <SelectItem value="user_created">User Created</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <Card className="border border-gray-200 shadow-sm rounded-sm">
        <CardContent className="p-4">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-xs font-semibold uppercase tracking-[0.1em] text-gray-500 border-b">
                  <th className="text-left py-3 px-3">Timestamp</th>
                  <th className="text-left py-3 px-3">User</th>
                  <th className="text-left py-3 px-3">Action</th>
                  <th className="text-left py-3 px-3">Entity</th>
                  <th className="text-left py-3 px-3">IP</th>
                  <th className="text-left py-3 px-3">Source</th>
                </tr>
              </thead>
              <tbody>
                {logs.length === 0 && <tr><td colSpan={6} className="py-8 text-center text-gray-400">No audit logs</td></tr>}
                {logs.map((l) => (
                  <tr key={l.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="py-3 px-3 text-xs text-gray-500 whitespace-nowrap">{l.created_at ? new Date(l.created_at).toLocaleString() : "—"}</td>
                    <td className="py-3 px-3 text-gray-700">{l.user_name || "System"}</td>
                    <td className="py-3 px-3"><Badge variant="secondary" className="text-[10px] rounded-sm">{l.action}</Badge></td>
                    <td className="py-3 px-3 text-gray-500 text-xs">{l.entity_type ? `${l.entity_type}/${l.entity_id?.slice(0, 8)}` : "—"}</td>
                    <td className="py-3 px-3 text-xs text-gray-400">{l.ip_address || "—"}</td>
                    <td className="py-3 px-3 text-xs text-gray-400">{l.source || "web"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
